import {put, select, takeLatest} from "redux-saga/effects"
import {network} from '../../utils/network'
import {endpointSlice} from './endpoingSlice'
import {userSlice} from "../user/userSlice"

function* fetch() {
  yield put(endpointSlice.actions.setLoading({type: 'endpoints', loading: true}))
  const user = yield select(store => store.user)
  const employeeEndpointId = user?.permissions?.user_data?.employee_endpoint_id
  try {
    const response = yield network.axios({
      method: 'GET',
      url: '/endpoint/',
    })
    yield put(endpointSlice.actions.setEndpoints(response.data))
    const localStorageEndpointId = localStorage.getItem('endpoint')
    const foundLocalStorage = response.data.find(i => i.id === localStorageEndpointId)
    const foundEmployee = response.data.find(i => i.id === employeeEndpointId)

    // У владельца платформы в списке лежат и точки заказчиков: при автовыборе
    // первой попавшейся он оказался бы в чужом контексте, поэтому предпочитаем
    // точку своего мерчанта (merchant_platform у него пустой).
    const ownMerchantIds = new Set(
      (user?.allPermissions ?? [])
        .filter(permission => !permission?.merchant_platform)
        .map(permission => permission?.merchant_id)
    )
    const foundOwn = response.data.find(i => ownMerchantIds.has(i.merchant_id))

    if (foundLocalStorage) {
      yield put(endpointSlice.actions.selectEndpoint(foundLocalStorage))
    } else if (foundEmployee) {
      yield put(endpointSlice.actions.selectEndpoint(foundEmployee))
    } else if (foundOwn) {
      yield put(endpointSlice.actions.selectEndpoint(foundOwn))
    } else {
      yield put(endpointSlice.actions.selectEndpoint(response.data[0] ?? {}))
      if (!response.data[0]) {
        yield put(userSlice.actions.setEndpointError(true))
        yield put(userSlice.actions.logout())
      }
    }
  } catch (e) {
    // todo: error?
  }
  yield put(endpointSlice.actions.setLoading({type: 'endpoints', loading: false}))
  yield put(userSlice.actions.setTokenLoading(false))
}

export function* endpointSagas() {
  yield takeLatest(endpointSlice.actions.fetch.type, fetch)
}
